import router from '@/mobile/router';
import AccountService from '@/service/AccountService';
import VueJwtDecode from 'vue-jwt-decode';

// initial state
const state = {
  token: null,
};

// getters
const getters = {
  token: (state) => {
    return state.token;
  },
  permission: (state) => {
    return VueJwtDecode.decode(state.token).permission;
  },
};

// actions
const actions = {
  setToken({ commit }, token) {
    if (token) {
      commit('setToken', token);
    }
  },
  logout({ commit }) {
    commit('logout');
    commit('profile/clear', null, { root: true });
    // 이전 방식으로 저장된 키 정리
    localStorage.removeItem('profile');
    localStorage.removeItem('profileNew');
    router.push('/login');
  },
  setPermission({ commit }, permission) {
    if (permission) {
      commit('setPermission', permission);
    }
  },
};

// mutations
const mutations = {
  setToken(state, token) {
    state.token = token; //state에 저장된 내용을 변경
  },
  logout(state) {
    state.token = null;
  },
  setPermission(state, permission) {
    state.permission = permission;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
